import React, { useMemo } from 'react'
import useFavurTranslation from 'hooks/useFavurTranslation'
import {
  HEADER_BUTTON_ANCHOR_ORIGIN,
  HEADER_BUTTON_TRANSFORM_ORIGIN,
} from 'redesign/components/organisms/action-wrapper/constants'
import MoreButton from 'redesign/components/organisms/more-button'
import { EditPencilIcon } from '../../Icon'
import type { RequestDeleteButtonProps } from './types'

const RequestDeleteButton: React.FC<RequestDeleteButtonProps> = ({ showDeleteButton, onClick }) => {
  const { t } = useFavurTranslation()

  const hiddenAction = useMemo(
    () => ({
      label: t('timeline.badge.deletion_request'),
      testId: 'absence-request_action-request_deletion',
      onClick,
    }),
    [onClick, t],
  )

  return showDeleteButton ? (
    <MoreButton
      icon={EditPencilIcon}
      hiddenActions={[hiddenAction]}
      anchorOrigin={HEADER_BUTTON_ANCHOR_ORIGIN}
      transformOrigin={HEADER_BUTTON_TRANSFORM_ORIGIN}
    />
  ) : null
}

export default RequestDeleteButton
